import { PermissionsService } from '@/core/services/permissions/permissions.service';
import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsGovGuard implements CanActivate {
  private readonly permissions = inject(PermissionsService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.permissions.resolveMe().pipe(
      map((me) => {
        if (me.whitelabel?.services?.has_platform_integration) {
          return true;
        }
        return this.router.createUrlTree(['/minhas-cameras']);
      }),
    );
  }
}
